<template>
    <div id="userReport">
        <a-row type="flex" justify="start">
            <a-col :style="{width:userReportCollapsed ? '80px': '15%'}">
                <div class="generic-left">
                    <div class="collapsed-left" @click="userREportToggleCollapsed">
                        <a-icon :type="userReportCollapsed ? 'left' : 'right'" />
                    </div>
                    <div class="generic-left-menu">

<!--                        <a-menu  mode="inline"-->
<!--                                 theme="light"-->
<!--                                 :selectedKeys="[defaulSelectValMenu]"-->
<!--                                 :inlineCollapsed="userReportCollapsed">-->
<!--                            <a-menu-item v-for="item in userReportMenu" :key="item.uid" @click="userReportTable(item,true)">-->
<!--                                <i class="anticon anticon-environment">-->
<!--                                    <span class="iconfont" v-bind:class="item.icon"></span>-->
<!--                                </i>-->
<!--                                <span style="font-size: 14px">{{item.name}}</span>-->
<!--                            </a-menu-item>-->
<!--                        </a-menu>-->

                        <a-menu mode="inline"
                                theme="light"
                                :selectedKeys="[defaulSelectValMenu]"
                                :inlineCollapsed="userReportCollapsed">
                            <a-menu-item v-for="item in userReportMenu"
                                         :key="item.uid"
                                         @click="userReportTable(item,true)"
                                         style="height: auto;">  <!-- 允许高度自适应 -->
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <i class="anticon anticon-environment" style="flex-shrink: 0;">
                                        <span class="iconfont" :class="item.icon"></span>
                                    </i>
                                    <span  :style="userReportCollapsed ?
            { fontSize: '14px' } :
            {
              fontSize: '14px',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              flex: '1',
              minWidth: '0',
              lineHeight: '20px',
              paddingTop: '10px',
              paddingBottom: '10px'

            }" >{{item.name}}</span>
                                </div>
                            </a-menu-item>
                        </a-menu>



                    </div>
                </div>
            </a-col>
            <a-col :style="{width:userReportCollapsed ? 'calc(100% - 85px)': 'calc(100% - 15%)'}" style="background: #fff">
                <a-row type="flex" justify="space-between" style="margin: 2px 0;">
                    <a-col style="margin-left: 4px;">
                        <a-row type="flex" align="middle">
                            <a-col><a-dropdown>
                                <span>
                                     <img class="sbxs" src="../../assets/img/ss-more.png"  width="22" height="22">
                                </span>
                                <a-menu slot="overlay">
                                    <a-menu-item @click="downUserreportExcel">
                                <span>
                                  <a-icon style="font-size: 16px" type="export"/>
                                  <span style="font-size: 12px;margin-left: 2px">Export</span>
                                </span>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown></a-col>
                            <a-col>
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>Refresh</span>
                                    </template>
                                    <img class="sbxs ml4"  src="../../assets/img/ss-refresh.png" width="20" height="20" @click="refersh">
                                </a-tooltip>
                            </a-col>
                            <a-col v-if="tableData.isPrintReport == '1'">
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>Print Report</span>
                                    </template>
                                    <img class="sbxs ml4"  src="../../assets/img/ss-import.png" width="20" height="20" @click="printReport">
                                </a-tooltip>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col>
                        <a-row type="flex" justify="start">
                            <a-col>
                                <a-pagination
                                        v-if="targetItem.isPaging == '1'"
                                        :pageSizeOptions="page.pageSizeOptions"
                                        :showTotal="total => `${$t('generic.totalOf')} ${page.pagingTotal} ${$t('generic.Records')}`"
                                        size="small"
                                        :total="page.pagingTotal"
                                        v-model="page.currentVal"
                                        :pageSize.sync="page.pagingSize"
                                        @change="tableChangePage"
                                        @showSizeChange="onShowSizeChange"
                                        showSizeChanger
                                        />
                            </a-col>
                            <a-col>
                                <a-dropdown>
                                    <a class="ant-dropdown-link">
                                        <img class="sbxs" src="../../assets/img/ss-more.png"  width="22" height="22">
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item style="font-size: 12px"  @click="andvanSearch">
                                            <a-icon type="zoom-in" /> {{ $t('pubGicSet.AdvanceSearch') }}
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                <a-row style="height: 84vh;">
                    <vxe-table
                            v-if="cols.length > 0"
                            stripe
                            highlight-hover-row
                            border
                            resizable
                            show-overflow
                            height="auto"
                            size="mini"
                            ref="tableDataListRef"
                            :data="tableData.data">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                        <template v-for="(item) in cols">
                            <vxe-table-column :title="item.label" :width="item.width" :field="item.prop" show-header-overflow="ellipsis" show-overflow="ellipsis" >
                                <!--<template v-slot="{ row }">{{ row[item.prop] }}</template>-->
                            </vxe-table-column>
                        </template>
                    </vxe-table>
                </a-row>
            </a-col>
        </a-row>
        <a-modal
            :title="$t('pubGicSet.AdvanceSearch')"
            :visible="Addvisible"
            @cancel="handleCancel"
            :maskClosable="false"
            width="85%">
            <template slot="footer">
                <a-button type="primary" @click="searchUserReport" size="small">{{$t('publicLang.Search')}}</a-button>
            </template>
            <a-row>
                <search-coms :menuTarget="targetItem" ref="searchComsRef"></search-coms>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import searchComs from "./userReport/searchComs.vue";

    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import { mapState } from "vuex";
    import axios from "axios";
    import cookie from "../../api/cookie";
    import moment from "moment";
    export default {
        components: {
            searchComs,
        },
        computed: {
            ...mapState(["lang"])
        },
        data() {
            return{
                userReportCollapsed: false,// 绽开开关
                userReportMenu: [], // menu data
                defaulSelectValMenu: '1', // menu 当前
                tableData: {}, // table  data
                cols: [], // 表头
                targetItem: {}, // 当前menu
                page:{ // 分页
                    pagingTotal: 0,
                    pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                    currentVal: 1,
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                },
//                advansearch
                Addvisible: false,
                advanceSearch: null,// 查询条件
                options: {
                    condition: [],
                    fieldNameSel: [],
                }
            }
        },
        created() {
            this.init()
        },
        watch:{
            lang(){
                this.init()
            }
        },
        methods: {
            refersh(){
                this.init()
            },
            printReport(){
                let Records = this.$refs.tableDataListRef.getCheckboxRecords();
                if (Records.length != 1) {
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 2);
                    return;
                }
                let that = this;
                // 构造参数
                let params = {
                    udrUid:this.defaulSelectValMenu,
                    dataList: JSON.stringify(Records),
                    cols:JSON.stringify(this.cols)
                }
                const p = new URLSearchParams(params).toString();
                const url = ajax.ajaxUrl()+api.PRINTPREVIEWBYUDR+`?${p}`;
                axios.get(url,{
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function(res) {
                    // 处理 PDF
                    console.error("res:", res);
                    console.error("data:", res.data);
                    if (res.data.size>200) {
                        // 如果是 PDF 文件
                        let blob = new Blob([res.data], {type: "application/pdf;charset=utf-8"});
                        var url = window.URL.createObjectURL(blob);
                        window.open(url);
                    } else {
                        // 如果不是 PDF，可能是错误信息，处理错误
                        const reader = new FileReader();
                        reader.onloadend = function() {
                            const jsonResponse = JSON.parse(reader.result);
                            console.error("服务器返回的错误信息:", jsonResponse);
                            that.$customMessage.warning(jsonResponse.msg);
                        };
                        reader.readAsText(res.data); // 读取返回的 blob 数据并解析为 JSON
                    }
                }).catch(function(error) {
                    console.error("请求失败:", error);
                });
            },
            downUserreportExcel(){
                let params = {
                    "advanceSearchDto2":this.advanceSearch,
                    "language": this.lang,
                    "uid": this.targetItem.uid
                }
                let ajaxurl = ajax.ajaxUrl();
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.exportExcel(ajaxurl+api.REPORTGENERICEXPORT,params).then(data=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if (!data) {
                        return;
                    }
                    var blob = new Blob([data.data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    var url = window.URL.createObjectURL(blob);
                    var aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", "excel.xlsx");
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            },
            userReportTable(item,type){
                this.cols = []
                this.targetItem = item
                if(type){
                    this.advanceSearch = null
                }
                let params = {
                    language: this.lang ,
                    paging: {
                        pageNum: this.page.currentVal,
                        pageSize: this.page.pagingSize,
                    },
                    uid: item.uid,
                    advanceSearchDto2: this.advanceSearch
                }

                ajax.post(api.REPORTGENERICQUERY,params).then(res=>{
                    if(res.code == 200){
                        this.defaulSelectValMenu = item.uid
                        this.tableData = res.data
                        this.cols = this.tableData.titles
                        this.page.pagingTotal = this.tableData.paging.totalPageSize
                    }else{
                        this.$customMessage.warning(res.msg);
                    }

                })
            },
//            初始化数据 获取menu
            init(){
                ajax.get(api.REPORTGENERICMENU).then(res=>{
                   this.userReportMenu = res.data
                    if(this.userReportMenu.length > 0){
                        if(Object.keys(this.targetItem).length >0){
                            this.userReportTable(this.targetItem)
                        }
                        this.defaulSelectValMenu = this.userReportMenu[0].uid
                   }
                })
            },
            userREportToggleCollapsed() {
                this.userReportCollapsed = !this.userReportCollapsed;
            },
//            分页
            tableChangePage(current){
                this.page.currentVal = current;
                this.userReportTable(this.targetItem)
            },
            onShowSizeChange(current, pageSize){
                this.page.currentVal = current;
                this.page.pagingSize = pageSize;
                this.userReportTable(this.targetItem)
            },

            searchUserReport(){
                let params  = this.$refs.searchComsRef.emitSearchDeail()
                params.rtMasterUid = this.targetItem.uid
                this.advanceSearch = params
                this.page.currentVal = 1
                this.userReportTable(this.targetItem)
                this.$refs.searchComsRef.clearData()
                this.Addvisible = false
            },
//            advanSearch 以下
            andvanSearch(){
              if(this.$refs.searchComsRef != null && this.$refs.searchComsRef != 'undefined'){
                           this.$refs.searchComsRef .init()
                }
                this.Addvisible = true
                this.$nextTick(()=>{
                    this.$refs.searchComsRef.clearData()
                    this.$refs.searchComsRef.getAdvanceSearch()
                })
            },
//            取消添加
            handleCancel(){
                this.advanceSearch = null
                this.Addvisible = false
            },
        }
    };
</script>
<style lang="less">
    .ml{
        margin-left: 4px;
    }
    #userReport>.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left{
        border: none;
    }
    .generic-right{
        float: right;
    }
    .generic-left {
        .generic-left-menu {
            overflow: hidden;
            overflow-y: auto;
            height: 82vh;
        }
        .collapsed-left {
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #e7eef8;
        }
    }
    @import "../../assets/css/bootstrap.css";
    #queryBuilder {
        overflow: hidden;
    }
    .queryBtnSty {
        margin: 4px 0;
    }
    .ant-drawer-body {
        padding: 2px;
    }
</style>

